module.exports = __webpack_public_path__ + "fonts/Roboto-LightItalic.cd2640dd.woff";